import React, { useState, useEffect } from 'react';
import { Box , Typography, Button, Table, TableBody, TableContainer, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import Modalnewrol from './Modalnewrol';
import AddIcon from '@mui/icons-material/Add';
import DeletePop from './Popdeleterol';
import Celda from './Celda';  
import Popeditrol from './Popeditrol'; 
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

import BASE_URL from '../../config';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: grey[100],
    color: theme.palette.common.black,
  }
}));

export default function RolesPage() {
  const [roles, setRoles] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/roles`);
      if (!res.ok) throw new Error("Error en la red o 404");
      const data = await res.json();
      setRoles(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Error cargando roles:", e);
      setRoles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchRoles(); }, []);

  return (
    <Box sx={{ p: 0, m: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 3,flexDirection: { xs: 'column', sm: 'row' },gap:2 }}>
        <Box>
          <Typography variant='h6'>Administración de Roles</Typography>
          <Typography variant='body1' color='textSecondary'>Gestiona roles y permisos del sistema</Typography>
        </Box>
        <Button
          variant="contained" 
          sx={{ bgcolor: 'black', textTransform: 'none', borderRadius: 2, width:{xs:'100%',sm:'auto' } }} 
          onClick={() => setOpenModal(true)}
          startIcon={<AddIcon/>}
        >
          Nuevo Rol
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{mt:3, maxHeight: 520 ,
        border:`1px solid ${grey[400]}` ,borderRadius: 3,
        overflowX: 'auto' , '&::-webkit-scrollbar': {
            display: 'none',
            },
            // Ocultar para Firefox
            scrollbarWidth: 'none',
            // Ocultar para Internet Explorer y Edge antiguo
            msOverflowStyle: 'none',}}>

        <Table sx={{minWidth: 200, }} stickyHeader  aria-label="customized table"> 
        <TableHead sx={{ bgcolor: grey[100] }}>
          <TableRow>
            <StyledTableCell sx={{fontWeight:'bold'}} >Rol</StyledTableCell>
            <StyledTableCell sx={{fontWeight:'bold'}}>Descripción</StyledTableCell>
            <StyledTableCell sx={{fontWeight:'bold'}}>Permisos</StyledTableCell>
            <StyledTableCell sx={{fontWeight:'bold'}} align="center">Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={4} sx={{ py: 10 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <CircularProgress size={40} sx={{ color: grey[500] }} />
                  <Typography sx={{ mt: 2, color: grey[600] }}>Cargando roles...</Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : roles.map((row) => (
            <TableRow  
                hover 
                key={row.id} 
                sx={{ 
                '&:last-child td, &:last-child th': { border: 0 },
                height: '60px' // Forzamos una altura consistente para todas las filas
              }}
            >
              {/* Columna Rol: Alineación perfecta con altura controlada */}
              <TableCell>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  lineHeight: 1, // Evita que el texto empuje el alto de la celda
                  gap: 1 
                }}>
                  <ShieldOutlinedIcon sx={{ fontSize: '1.25rem' }} />
                  <Typography variant="body2">
                    {row.nombre}
                  </Typography>
                </Box>
              </TableCell>

              <TableCell variant='body'>{row.descripcion}</TableCell>

              <TableCell variant='body'>
                <Celda permisosArray={row.permisos} />
              </TableCell>

              <TableCell align="center" sx={{width:100}}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                    <Popeditrol rol={row} refresh={fetchRoles} />
                    <DeletePop rol={row} refresh={fetchRoles} />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        </Table>
      </TableContainer>

      <Modalnewrol 
        open={openModal} 
        handleClose={() => setOpenModal(false)} 
        refreshRoles={fetchRoles} 
      />
    </Box>
  );
}